/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchReadinessStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PatchReadinessStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return PatchReadinessStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PatchReadinessStatusQueryOperator>): PatchReadinessStatusQueryOperator {
        let obj = Object.assign(new PatchReadinessStatusQueryOperator(), model);
        PatchReadinessStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchReadinessStatusQueryOperator>): PatchReadinessStatusQueryOperator {
        if (!model) return null;
        return PatchReadinessStatusQueryOperator.newInstance(<PatchReadinessStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchReadinessStatusQueryOperator) {
        if (!obj) return;

        models.PatchReadinessStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchReadinessStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PatchReadinessStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Patch Readiness status to include
     */
    patch_readiness_status: Array<models.PatchReadinessStatusTypes>;

}
